import { Typography } from 'src/components/Typography';

import { Box } from '../../components/Box';
import { Stack } from '../../components/Stack';

interface Props {
  title?: string | React.ReactNode;
  children: React.ReactNode;
  showIf?: boolean;
  actions?: React.ReactNode;
  disableChildPadding?: boolean;
  disableBorder?: boolean;
  sx?: any;
}

export const AppointmentCardSection: React.FC<Props> = ({
  title,
  children,
  showIf = true,
  actions = null,
  disableChildPadding = false,
  disableBorder = false,
  sx = {},
}) => {
  if (!showIf) return null;
  return (
    <Box
      borderTop={disableBorder ? 0 : 1}
      borderColor="divider"
      sx={{ pb: 1, pt: 1, ...sx }}
    >
      <Stack sx={{ px: disableChildPadding ? 0 : 2 }}>
        {(!!title || !!actions) && (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ px: disableChildPadding ? 2 : 0, mb: 1 }}
          >
            {title && (
              <Typography variant="subtitle2" sx={{ my: 1.2 }}>
                {title}
              </Typography>
            )}
            {actions}
          </Stack>
        )}
        {children}
      </Stack>
    </Box>
  );
};
